import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class AnswerQuestionForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
       section: null,


        };


        this.handleInputChange = this.handleInputChange.bind(this);

    }

    componentDidMount() {
    }





    handleChange = (e, { value }) => {// console.log(this.state.value);
         this.setState({ value })};

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {

        return (
            <div>

                <Form noValidate>
                    <Grid columns={2} centered stackable >
                        <Grid.Column width={12} stretched>
                            <Form.Field required error={this.state.textErr}>
                                <label>
                                    {/* {<FormattedMessage id="common.title" />} */}
                                     {<FormattedMessage id="poll.question" />}
                                    {/*Pitanje*/}
                                </label>
                                <FormattedMessage id="poll.placeholderQuestion">
                                    {(msg) => (<input
                                        required
                                        fluid
                                        placeholder={msg}
                                        control={Input}
                                        value={this.state.text}
                                        name="text"
                                        onChange={(e) => this.setState({ text: e.target.value })}

                                    />)}
                                </FormattedMessage>
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={4} stretched>
                            <Form.Group widths='equal'
                            >

                                <Form.Field>
                                    <label>
                                         {<FormattedMessage id="poll.section" />}
                                        {/*Sekcija*/}
                                    </label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={<FormattedMessage id="common.section" />}
                                        value={this.state.section}
                                        onChange={this.handleInputChange}
                                        name="section"
                                        options={this.props.sections}
                                        search
                                        fluid
                                        selection
                                        required
                                        error={this.state.sectionErr}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Grid.Column>
                    </Grid>
                </Form>

                    <Button
                        onClick={this.props.closeQuestionForm}
                        floated="right"
                        color="blue"
                        basic
                    >
                        {<FormattedMessage id="poll.cancel" />}
                    </Button>
                    <Button
                       onClick={()=>this.props.createQuestion(this.state.text, this.state.section)}
                        floated="right"
                        color="blue"
                        primary
                    >
                        {<FormattedMessage id="poll.addQuestionButton" />}
                    </Button>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionForms/AnswerQuestionForm.js